import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { CareRecipientWithDataSyncInformation } from "../../../../domain/care_recipient/CareRecipientWithDataSyncInformation";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { CareRecipientName } from "../../../../domain/care_recipient/CareRecipientName";
import { CareRecipientHouseId } from "../../../../domain/care_recipient/CareRecipientHouseId";
import { DateTime } from "../../../../domain/fundamental/DateTime";
import { DateObject } from "../../../../domain/fundamental/DateObject";

export const useSearchedCareRecipientList = (): CareRecipientWithDataSyncInformation[] | null => {
    const responseJson = useSelector((state: State) => state.adminCareRecipient.searchedCareRecipientList.list);

    return responseJson ? responseJson.map(recipient =>
        CareRecipientWithDataSyncInformation.from(
            CareRecipientId.fromString(recipient.id),
            CareRecipientName.fromString(recipient.name),
            null,
            recipient.houseId ? CareRecipientHouseId.fromString(recipient.houseId) : null,
            null,
            recipient.dataSyncStartTime ? DateTime.fromString(recipient.dataSyncStartTime) : null,
            recipient.dataSyncEndTime ? DateTime.fromString(recipient.dataSyncEndTime) : null,
            recipient.alertPeriod?.start ? DateObject.fromString(recipient.alertPeriod.start) : null,
            recipient.alertPeriod?.end ? DateObject.fromString(recipient.alertPeriod.end) : null,
        )
    ) : null;
};
